var map = {
	"./BubbleSort.md": [
		74,
		3
	],
	"./BucketSort.md": [
		75,
		4
	],
	"./CombSort.md": [
		76,
		5
	],
	"./CountingSort.md": [
		77,
		6
	],
	"./HeapSort.md": [
		78,
		7
	],
	"./InsertionSort.md": [
		79,
		8
	],
	"./MergeSort.md": [
		80,
		9
	],
	"./QuickSort.md": [
		81,
		10
	],
	"./RadixSort.md": [
		82,
		11
	],
	"./SelectionSort.md": [
		83,
		12
	],
	"./TimSort.md": [
		84,
		13
	],
	"./TreeSort.md": [
		85,
		14
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 70;
module.exports = webpackAsyncContext;